import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin';
import {  Router } from '@angular/router';
import { CMSService } from '../../services/cms-service';
import { Popup } from 'ng2-opd-popup';
import { Message } from 'model/modal-cms/message';
//import { NumberSymbol } from '../../../../node_modules_derika/@angular/common';
import Swal from 'sweetalert2'
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var info_message3 = mdtoast("Vous avez réçus de nouveau message(s)", { duration: 5000, init: true, type: mdtoast.INFO });
var success_message4 = mdtoast("Message, bien envoyer.", { duration: 5000, init: true, type: mdtoast.SUCCESS });


@Component({
  selector: 'app-questonaire',
  templateUrl: './questonaire.component.html',
  styleUrls: ['./questonaire.component.scss']
})
export class QuestonaireComponent implements OnInit {
  motCle(arg0: any, arg1: any): any {
    throw new Error("Method not implemented.");
  }
  listeQuiestionByEtatCreer: any;
  listeQuiestionByEtatlire: any;
  @ViewChild('popupProcedure') popupProcedure: Popup;
  message: Message = new Message(null);
  id_agent_actuel: any;
  nbr_quest_en_attante:number;
  mode_recherche: number=1;
  eta_mess_actuel:any;
  motCle2 :any;
  constructor(private adminService: AdminService,private router: Router, private cMSService : CMSService ) {
    this.id_agent_actuel = this.adminService.getUserIMIscrit(); 
   }
  nombre:number=1;

  ngOnInit() {
    console.log("alefa compte a listeQuiestionByEtatCreer " )
    this.GetQuestionbyEtatCeer();
    this.GetQuestionbyEtatLire();
    this.getnombreQuestionEnAttante();
  }

    onChange(deviceValue) {
    console.log(deviceValue);  
    if(deviceValue=="d") {
      //recherche par Date
         this.mode_recherche=1;
    }else if(deviceValue=="m") {
      //recherche par mesage
      this.mode_recherche=2;
    }else if(deviceValue=="t") {
      //recherche tous messages
         this.mode_recherche=3;
      this.getToutMessage();
    }
   
    
   }

   onChangedefault(eventdefault){
    this.eta_mess_actuel = eventdefault

   }


RechercheMessageParDate(){
    this.cMSService.getListeQuestionParMCComParDate(this.motCle,this.eta_mess_actuel)
    .subscribe(data => {
      if(this.eta_mess_actuel=="c"){
  this.listeQuiestionByEtatCreer = data
      }else{
        this.listeQuiestionByEtatlire = data
      }
    
      
    }, err => {
      console.log(err);
    })
  }

  RechercheMessage(){
     console.log(this.motCle2); 
    this.cMSService.getListeQuestionParMCCom(this.motCle2,this.eta_mess_actuel)
    .subscribe(data => {
      if(this.eta_mess_actuel=="c"){
  this.listeQuiestionByEtatCreer = data
      }else{
        this.listeQuiestionByEtatlire = data
      }
    }, err => {
      console.log(err);
    })
  }
  
  
  getParDate(){
    this.mode_recherche=1
  }
  
  
  getToutMessage(){
    this.GetQuestionbyEtatCeer();
    this.GetQuestionbyEtatLire();
  
  }
  
  getParMessage(){
    this.mode_recherche=2  
  }

  
  getnombreQuestionEnAttante() {
    this.adminService.getnombreQuestionEnAttante("c")
        .subscribe(data => {
            this.nbr_quest_en_attante = data;
           console.log("  this.nbr_quest_en_attante = data;"  +data)
            if( this.nbr_quest_en_attante != 0){
                info_message3.show();   
            }
        }, err => {

        })
}


  // private adminService: AdminService,
  listeQuiestion(){
    this.cMSService.getListeQuestion()
    .subscribe(data => {      
        console.log("alefa compte a " + data)
    }, err => {
        console.log(err);
    })
  }

  GetQuestionbyEtatCeer(){
    this.cMSService.getListeQuestiobyEtatCreer("c")
    .subscribe(data => {
      this.listeQuiestionByEtatCreer = data
      console.log("alefa compte a listeQuiestionByEtatCreer " + data)
    }, err => {
      console.log(JSON.parse(err._body).message);
    })
  }

  
  GetQuestionbyEtatLire(){
    this.cMSService.getListeQuestiobyEtatLire("l")
    .subscribe(data => {
      this.listeQuiestionByEtatlire = data
      console.log("alefa compte a listeQuiestionByEtatCreer " + data)
    }, err => {
      console.log(JSON.parse(err._body).message);
    })
  }
  


  ouvrirDetailConsultation(id:number,id2:any){
    this.router.navigate(['detail-question/'+id+"/"+id2]);
  }

  repondreConsultation(id:number,id2){
    this.router.navigate(['detail-question/'+id+"/"+id2]);
  }


  open() {
    this.popupProcedure.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: "Question réponse",
      widthProsentage: 35,
      animation: "fadeInUp",
      confirmBtnContent: "Envoyer",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);
    
  }

  EnvoyerMessage(tel,mail,contenu){
    Swal.fire({
      title: 'Envoi message',
      icon: 'info',
      text: contenu,
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Envoyer!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.message.im_dest= this.id_agent_actuel
        this.message.nom_dest= ""      
        this.message.prenom_dest=""
        this.message.direction_g =""
        this.message.direction=""
        this.message.service =""
        this.message.etat_mess ="c"
       this.message.tel_dest = tel;
       this.message.mail_dest = mail;
       this.message.contenue_mess = contenu;
        this.cMSService.saveMessage(this.message)
        .subscribe(data => {
          success_message4.show();  
        }, err => {
          // console.log(JSON.parse(err._body).message);
        })



      

      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });

  }

 
}
